(function () {
  if (window.__bhPersonalizeValidate) return;
  window.__bhPersonalizeValidate = true;

  // limits + messages come from the card (snippets/bh-personalize.liquid → window.BH_PERSONALIZE, editable in
  // /pages/admin-personalization → «النصوص والحدود»); the values below are the fallback
  var cfg = function () { return window.BH_PERSONALIZE || {}; };
  var lim = function (k, d) { var l = cfg().limits || {}; var n = parseInt(l[k], 10); return n > 0 ? n : d; };

  var isAr = (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
  var MSG_DEFAULT = isAr
    ? {
        name: 'الرجاء كتابة الاسم',
        phrase: 'الرجاء كتابة الجملة',
        font: 'الرجاء اختيار نوع الخط',
        color: 'الرجاء اختيار اللون',
        file: 'الرجاء رفع ملف التصميم',
        mode: 'الرجاء اختيار طريقة التصميم',
        fill: 'الرجاء تعبئة:'
      }
    : {
        name: 'Please enter the name',
        phrase: 'Please enter the phrase',
        font: 'Please choose a font',
        color: 'Please choose a colour',
        file: 'Please upload your design file',
        mode: 'Please choose a design method',
        fill: 'Please fill in:'
      };
  // read on use: the card's settings script may run after this file
  var MSG = new Proxy({}, { get: function (_, k) { var m = cfg().msg || {}; return (m[k] && String(m[k]).trim()) || MSG_DEFAULT[k]; } });

  function byId(id) { return document.getElementById(id); }

  function injectStyle() {
    if (byId('bh-pv-style')) return;
    var st = document.createElement('style');
    st.id = 'bh-pv-style';
    st.textContent =
      '.bh-pv-error{display:block;margin:6px auto 0;color:#b3261e;font-size:13px;font-weight:600;text-align:center;line-height:1.4}' +
      '.bh-pv-invalid{outline:2px solid #b3261e !important;outline-offset:2px;border-radius:8px}';
    document.head.appendChild(st);
  }

  function clearErrors() {
    document.querySelectorAll('.bh-pv-error').forEach(function (n) { n.remove(); });
    document.querySelectorAll('.bh-pv-invalid').forEach(function (n) { n.classList.remove('bh-pv-invalid'); });
  }

  function mark(target, message) {
    if (!target) return;
    injectStyle();
    target.classList.add('bh-pv-invalid');
    var note = document.createElement('span');
    note.className = 'bh-pv-error';
    note.setAttribute('role', 'alert');
    note.textContent = message;
    target.insertAdjacentElement('afterend', note);
  }

  function belongsTo(el, form) { return !el || !form || !el.form || el.form === form; }

  function pickerFor(colorEl) {
    if (!colorEl || !colorEl.id) return null;
    var swatch = document.querySelector("[onclick*=\"'" + colorEl.id + "'\"]");
    return swatch ? (swatch.closest('.color-picker') || swatch.parentElement) : null;
  }

  function checkGroup(errors, nameEl, fontEl, fontTrigger, colorEl, colorPicker, required, nameMsg) {
    if (!nameEl) return;
    var hasName = nameEl.value.trim() !== '';
    if (!hasName) {
      if (required) errors.push([nameEl, nameMsg]);
      return;
    }
    if (fontEl && !fontEl.value) errors.push([fontTrigger || fontEl, MSG.font]);
    if (colorEl && !colorEl.value) errors.push([colorPicker || colorEl, MSG.color]);
  }

  function validate(form) {
    clearErrors();

    var nameEl = byId('BabyName') || byId('Phrase');
    var fileEl = byId('file-upload');
    var radios = document.querySelectorAll('input[type="radio"][name="design_option"]');

    if (!nameEl && !fileEl) return true;
    if (!belongsTo(nameEl || fileEl, form)) return true;

    var errors = [];
    var mode = null;

    if (window.bhSpecialSync) { try { window.bhSpecialSync(); } catch (e) {} }

    if (radios.length) {
      var checked = Array.prototype.filter.call(radios, function (r) { return r.checked; })[0];
      if (!checked) errors.push([document.querySelector('.design-choice-wrapper') || radios[0], MSG.mode]);
      else mode = checked.value;
    }

    var fileTarget = fileEl ? (fileEl.closest('.file-upload-wrapper') || byId('file-label') || fileEl) : null;
    var hasFile = !!(fileEl && fileEl.files && fileEl.files.length);

    var specialName = byId('BhSpecialName');
    if (specialName && !specialName.disabled && belongsTo(specialName, form) && specialName.value.trim() === '') {
      errors.push([specialName, MSG.name]);
    }

    if (mode === 'upload_image') {
      if (!hasFile) errors.push([fileTarget, MSG.file]);
      // colour picker shown under the upload zone («ارفع تصميم جاهز» mode, not the special card)
      var upColor = byId('BabyColor') || byId('PhraseColor');
      var upPicker = pickerFor(upColor);
      if (upColor && upPicker && upPicker.offsetParent !== null && !upColor.value) errors.push([upPicker, MSG.color]);
    } else if (!errors.length) {
      if (nameEl) {
        checkGroup(
          errors, nameEl,
          byId('fontSelectBaby'), byId('fontTriggerBaby'),
          byId('BabyColor') || byId('PhraseColor'), pickerFor(byId('BabyColor') || byId('PhraseColor')),
          true, nameEl.id === 'Phrase' ? MSG.phrase : MSG.name
        );
        var extra = byId('EnglishName');
        checkGroup(
          errors, extra && extra.offsetParent !== null ? extra : null,
          byId('fontSelectEnglish'), byId('fontTriggerEnglish'),
          byId('EnglishColor'), pickerFor(byId('EnglishColor')),
          false, MSG.name
        );
      } else if (fileEl && !hasFile) {
        errors.push([fileTarget, MSG.file]);
      }
    }

    if (mode !== 'upload_image') {
      document.querySelectorAll('[data-bh-required]').forEach(function (el) {
        if (!belongsTo(el, form) || el.value.trim() !== '') return;
        var label = el.getAttribute('data-bh-required').replace(/[:：]\s*$/, '');
        errors.push([el, MSG.fill + ' ' + label]);
      });
    }

    if (!errors.length) return true;

    errors.forEach(function (e) { mark(e[0], e[1]); });
    var first = errors[0][0];
    if (first && first.scrollIntoView) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (first && first.focus && /^(INPUT|TEXTAREA|BUTTON)$/.test(first.tagName)) {
      try { first.focus({ preventScroll: true }); } catch (e) {}
    }
    return false;
  }

  window.bhValidatePersonalization = validate;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"], form[action*="/cart/add"]')) return;
    if (!validate(form)) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  ['input', 'change', 'click'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (!document.querySelector('.bh-pv-error')) return;
      var t = e.target;
      if (t && t.closest && t.closest('[data-buy-now-go-cart], button[type="submit"][name="add"]')) return;
      if (evt === 'click' && !(t && t.closest && t.closest('.color-option, .font-trigger, .design-card, label[for="file-upload"], #fontSheet, .font-sheet'))) return;
      clearErrors();
    }, true);
  });

  function clearFile() {
    var input = byId('file-upload');
    if (!input) return;
    try {
      var desc = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
      desc.set.call(input, '');
    } catch (e) {}
    try { if (input.files && input.files.length) input.files = new DataTransfer().files; } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('#remove-file')) clearFile();
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.name !== 'design_option') return;
    if (t.value === 'name_design') clearFile();
    if (t.value === 'upload_image') {
      document.querySelectorAll('.custom-addon-textarea').forEach(function (el) { el.value = ''; });
    }
  }, true);

  function setLimits() {
    // the main field takes the template's own limit (if set), the second name and the special-design name the name limit
    var primary = byId(cfg().primaryId || 'BabyName');
    if (primary) primary.setAttribute('maxlength', lim('primary', primary.id === 'Phrase' ? 80 : 40));
    ['BabyName', 'EnglishName', 'BhSpecialName'].forEach(function (id) {
      var el = byId(id);
      if (el && el !== primary) el.setAttribute('maxlength', lim('name', 40));
    });
    var phrase = byId('Phrase');
    if (phrase && phrase !== primary) phrase.setAttribute('maxlength', lim('phrase', 80));
  }

  function ownText(label) {
    var t = '';
    label.childNodes.forEach(function (n) { if (n.nodeType === 3) t += n.nodeValue; });
    return t.split(/[ \t\n\r]+/).join(' ').trim();
  }

  function layoutPills(root) {
    (root || document).querySelectorAll('fieldset.product-form__input--pill').forEach(function (fs) {
      var longest = 0;
      fs.querySelectorAll('label').forEach(function (l) { longest = Math.max(longest, ownText(l).length); });
      var cols = longest > 0 && longest <= 9 ? '3' : '2';
      if (fs.getAttribute('data-bh-cols') !== cols) fs.setAttribute('data-bh-cols', cols);
    });
  }

  function watchPills() {
    layoutPills();
    var host = document.querySelector('variant-selects');
    if (host && host.parentElement && window.MutationObserver) {
      new MutationObserver(function () { layoutPills(); }).observe(host.parentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchPills);
  else watchPills();

  function resetCard() {
    var btn = byId('resetButton');
    if (!btn) return null;
    return btn.closest('#name-design-section, #image-upload-section, .design-choice-wrapper, .product__info-wrapper, form') || btn.parentElement;
  }
  function cardHasData() {
    var card = resetCard();
    if (!card) return false;
    if (card.querySelector('.color-option.active, .addon-check:checked')) return true;
    var fields = card.querySelectorAll('input, textarea, select');
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i], t = (f.type || '').toLowerCase(), name = f.name || '';
      var isProp = /^properties\[/.test(name) || t === 'file' || f.id === 'BabyName' || f.id === 'EnglishName' || f.id === 'Phrase';
      if (!isProp || t === 'submit' || t === 'button' || t === 'reset' || t === 'radio') continue;
      if (/^properties\[_/.test(name)) continue; // internal (underscore) properties
      if (t === 'checkbox') { if (f.checked) return true; continue; }
      if (t === 'file') { if (f.files && f.files.length) return true; continue; }
      if (f.tagName === 'SELECT') { if (f.value && f.selectedIndex > 0) return true; continue; }
      if (String(f.value || '').trim()) return true;
    }
    return false;
  }
  var armTimer = null;
  function armReset() {
    var btn = byId('resetButton');
    if (!btn) return;
    btn.classList.toggle('is-armed', cardHasData());
  }
  function armSoon() { clearTimeout(armTimer); armTimer = setTimeout(armReset, 60); }
  ['input', 'change', 'click', 'keyup'].forEach(function (ev) { document.addEventListener(ev, armSoon, true); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', armReset);
  else armReset();
  window.addEventListener('pageshow', armSoon);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setLimits);
  else setLimits();
})();

(function () {
  var vids = document.querySelectorAll('video[data-bh-autoplay]');
  if (!vids.length) return;
  function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  if (!('IntersectionObserver' in window)) { vids.forEach(play); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; play(v); }
      else if (!v.paused) v.pause();
    });
  }, { rootMargin: '200px 0px' });
  vids.forEach(function (v) { io.observe(v); });
})();
